/* global axios */
import ApiClient from './ApiClient';

class TypeAheadAPI extends ApiClient {
  constructor() {
    super('typeahead', { accountScoped: true });
  }

  get({ search, page = 1, perPage = 15 }) {
    const url = search
      ? `${this.url}?&search=${search}&page=${page}&per_page=${perPage}`
      : `${this.url}?page=${page}&per_page=${perPage}`;
    return axios.get(url);
  }
}

export default new TypeAheadAPI();
